import { TextInput } from '@framework/form';
import React from 'react';
import { ConfigFormItem } from '../../../../../../ui/form/ConfigFormItem';
import { DivInputStyle } from '../../../../../../ui/form/DivInputStyle';
import { ComputeExpressionPreview } from '../../../../../expressions/compute/preview/ComputeExpressionPreview';
import { IWidgetParsedProps } from '../../../inputs/common/util/getWidgetProps';
import { PaymentRowWidgetFieldConfig } from '../IPaymentRowWidget';

export interface IPaymentRowFieldPreviewProps {
  config: PaymentRowWidgetFieldConfig;
  options: IWidgetParsedProps;
  label: string;
}

export function PaymentRowFieldPreview(props: IPaymentRowFieldPreviewProps) {
  const { config, options, label } = props;

  if (config.editable) {
    return (
      <ConfigFormItem name="string" label={label} readonly={options.readonly}>
        <TextInput name={options.name} />
      </ConfigFormItem>
    );
  }

  return (
    <ConfigFormItem name="string" label={label} readonly={options.readonly}>
      <DivInputStyle>
        <ComputeExpressionPreview expression={config.expression} />
      </DivInputStyle>
    </ConfigFormItem>
  );
}
